const QUESTION_VOICE_STORAGE_KEY = 'mindstamp_preferred_question_voice_number'
const DEFAULT_QUESTION_VOICE_NUMBER = 0

const normalizeQuestionVoiceNumber = (value) => {
  const parsedValue = Number.parseInt(value, 10)
  return Number.isInteger(parsedValue) && parsedValue >= 0
    ? parsedValue
    : DEFAULT_QUESTION_VOICE_NUMBER
}

export const readPreferredQuestionVoiceNumber = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return DEFAULT_QUESTION_VOICE_NUMBER
  }

  try {
    return normalizeQuestionVoiceNumber(
      window.localStorage.getItem(QUESTION_VOICE_STORAGE_KEY)
    )
  } catch (_error) {
    return DEFAULT_QUESTION_VOICE_NUMBER
  }
}

export const writePreferredQuestionVoiceNumber = (value) => {
  const normalizedValue = normalizeQuestionVoiceNumber(value)

  if (typeof window === 'undefined' || !window.localStorage) {
    return normalizedValue
  }

  try {
    window.localStorage.setItem(
      QUESTION_VOICE_STORAGE_KEY,
      String(normalizedValue)
    )
  } catch (_error) {
    return normalizedValue
  }

  return normalizedValue
}
